import React, { useEffect, useState } from 'react';
import { MaskedInput, RegularButton } from 'fronton-react';
import { GenerateCodeContainer, GenerateCodeWrapper } from './styles';
import { normalizePhone } from 'utils/format-phone';
import { useTranslation } from 'react-i18next';

interface IGenerateCode {
  sendCode: (phoneNumber: string) => void;
  loading: boolean;
  error: string | null;
  forcedPhoneNumber: string | null;
}

export const QA_GENERATE_CODE_INPUT = 'generate-code-input';

export const GenerateCode: React.FC<IGenerateCode> = ({ sendCode, loading, error, forcedPhoneNumber }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>('');

  useEffect(() => {
    if (forcedPhoneNumber) {
      setValue(forcedPhoneNumber);
    }
  }, [forcedPhoneNumber]);

  const handleSend = () => {
    sendCode(normalizePhone(value));
  };

  return (
    <GenerateCodeContainer>
      <GenerateCodeWrapper>
        <MaskedInput
          data-qa={QA_GENERATE_CODE_INPUT}
          alwaysShowMask
          maskPlaceholder="_"
          label={t('loyalty-registration-modal.generate-phone-step.phone-number')}
          mask="+7 999 999 99 99"
          onChange={(_, inputValue) => setValue(inputValue)}
          allowClear
          value={value}
          fullWidth
          disabled={loading || !!forcedPhoneNumber}
          error={!!error}
          captionMessage={error || ''}
        />
        <RegularButton
          data-qa="send-code-button"
          loading={loading}
          wide
          variant="accent"
          size="l"
          onClick={handleSend}
        >
          {t('loyalty-registration-modal.generate-phone-step.get-code')}
        </RegularButton>
      </GenerateCodeWrapper>
    </GenerateCodeContainer>
  );
};
